<template>
  <div class="row">
    <div class="col image-container">
      <label class="label">รูปปก</label>
      <img class="image" :src="thumbnailUrl" />
      <sc-button
        class="thumbnail-button"
        v-if="!disabled"
        @click="handleClickChooseLogoButton"
        >รูป icon​</sc-button
      >
    </div>
    <div class="col info-editor">
      <label class="label">หัวข้อ</label>
      <el-input
        class="input"
        :disabled="disabled"
        :value="label"
        @input="handleChange('label', $event)"
      ></el-input>
      <label class="label">คำอธิบาย</label>
      <el-input
        class="input"
        :disabled="disabled"
        :value="description"
        @input="handleChange('description', $event)"
      ></el-input>
      <label class="label">URL</label>
      <el-input
        class="input"
        :disabled="disabled"
        :value="url"
        @input="handleChange('url', $event)"
      ></el-input>
    </div>
    <image-picker-modal
      v-bind="chooseLogoDialog"
      @cancel="handleCancelChooseLogoDialog"
      @confirm="handleConfirmChooseLogoDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ImagePickerModal from "@/lib/components/ImagePickerModal";

export default {
  props: ["value", "logoUrl", "disabled"],
  components: {
    "el-input": Input,
    ScButton,
    ImagePickerModal
  },
  data() {
    return {
      isShowModal: false
    };
  },
  computed: {
    label() {
      return this.value.label;
    },
    description() {
      return this.value.description;
    },
    url() {
      return this.value.url;
    },
    thumbnailUrl() {
      if (!this.chooseLogoDialog.thumbnailUrl) {
        return "https://placehold.co/300";
      }

      return this.chooseLogoDialog.thumbnailUrl;
    },
    chooseLogoDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: !this.disabled,
        title: "เลือกรูปicon",
        width: 200,
        height: 200,
        recommendWidth: 200,
        recommendHeight: 200,
        thumbnailFile: this.value.logoFile,
        thumbnailUrl: this.logoUrl
      };
    }
  },
  methods: {
    handleChange(key, value) {
      this.$emit("input", { ...this.value, [key]: value });
    },
    handleClickChooseLogoButton() {
      this.showChooseLogoDialog();
    },
    handleCancelChooseLogoDialog() {
      this.hideChooseLogoDialog();
    },
    handleConfirmChooseLogoDialog(file) {
      this.$emit("input", { ...this.value, logoFile: file });
      this.hideChooseLogoDialog();
    },
    showChooseLogoDialog() {
      this.isShowModal = true;
    },
    hideChooseLogoDialog() {
      this.isShowModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  padding: 30px;
  border-bottom: $border;
}

.meta {
  padding-left: 30px;
  display: block;
  flex-grow: 1;

  > .name {
    display: inline-block;
    font-size: 1rem;
  }

  > .desc {
    overflow: hidden;
    height: 25px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.item {
  display: flex;
  flex-direction: row;
  padding: 30px;
  border-bottom: $border;
}

.image {
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px solid #dcdfe6;
  width: 100%;
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.info-editor {
  max-width: calc(100% - 225px);
}

.label {
  margin-bottom: 5px;
  margin-top: 10px;
  padding: 0 15px;
  display: block;
  line-height: 1.6;
  font-size: 1rem;
  font-weight: 700;
}

.input {
  margin-bottom: 20px;
  width: 100%;
}

.thumbnail-button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/features/insurance/components/InsuranceEditor.vue